export const LABELS = {
    EMAIL: 'Email address',
    PASSWORD: 'Password',
    FORGOT_PASSWORD_DESC: 'Enter the email address associated with your account, and we’ll email you a link to reset your password',
    REGISTER: 'Register New Account',
    BUTTON: {
        LOGIN: 'LOGIN',
        SEND_RESET_LINK: 'Send Reset Link'
    }
}